import { useContext } from 'react';

import { XYChartConfigContext } from '../context/XYChartConfig.context.js';
import type { XYChartSlots } from '../types/xy-chart-internals.js';
import type { XYChartProps } from '../types/xy-chart.js';
import {
  createXYChartConfiguration,
  deserializeConfig,
} from '../utils/xy-chart-configuration.js';

export const useXYChartConfig = (props: XYChartProps, slots: XYChartSlots) => {
  const config = useContext(XYChartConfigContext);
  const { colorPalette, truncationMode } = props;
  const isImportedConfig = typeof config === 'string';
  const contextConfig = isImportedConfig ? deserializeConfig(config) : config;

  return createXYChartConfiguration(slots, contextConfig, {
    colorPalette,
    truncationMode,
  });
};
